<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import normalPrint from "./normal/index.vue";

const textAlign = "right";
const labelWidth = 90;
@Component({
  name: "ordinary-deduction-new",
  components: {
    normalPrint
  }
})
export default class App extends Vue {
  mounted() {
  }
  render(h) {
    return (
      <div class="preformed-invoice">
        <normal-print></normal-print>
      </div>
    );
  }
}
</script>
